export enum UlogeEnum {
    ADMINISTRATOR_METAREGISTRA = "Администратор метарегистра",
    ADMINISTRATOR_ORGANA_ZA_METAREGISTAR = "Администратор органа за метарегистар",
}